import useManualSort from '@/composables/sort/manual-sort';
import { savedView as savedViewConfig } from 'shared/api/query/configs.json';

export default function useGoalViewSort(viewsService) {
  const updateSort = ({ entity, sortOperation }) => viewsService.updateSort(entity, sortOperation);
  const { listBefore, listAfter } = useManualSort(savedViewConfig.edges.goalSort, updateSort);
  return { listBefore, listAfter };
}
